import cleanedFilename from '~/util/cleanedFilename';

export default {
  INPUT: `${cleanedFilename(__filename)}-input`,
};
